import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=827e5264&scoped=true"
import script from "./EventCalendar.vue?vue&type=script&lang=js"
export * from "./EventCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827e5264",
  null
  
)

export default component.exports